const ADMIN_ROUTES = ['users'];

export default ADMIN_ROUTES;
